import "core-js/modules/es6.reflect.construct.js";
import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { bindAll, isNumber } from './common';
import Icon from '../../wui-icon/src';
import { WebUI } from "../../wui-core/src/index.js";
var propTypes = {
  placement: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  hasHeader: PropTypes.bool,
  show: PropTypes.bool,
  title: PropTypes.any,
  className: PropTypes.string,
  showMask: PropTypes.bool,
  maskClosable: PropTypes.bool,
  zIndex: PropTypes.number,
  showClose: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  destroyOnClose: PropTypes.bool,
  container: PropTypes.any,
  closeIcon: PropTypes.node
};
var defaultProps = {
  placement: 'right',
  // 抽屉的位置。有四个预置的选项: left,right,top,bottom
  hasHeader: true,
  // 是否显示Drawer的头部信息
  show: false,
  // 是否显示抽屉组件
  showMask: true,
  // 是否显示遮罩
  maskClosable: true,
  // 点击遮罩是否可以关闭抽屉
  zIndex: 100,
  // 抽屉容器的层级，可以修改层级
  showClose: false,
  // 是否显示关闭按钮
  width: 'auto',
  // 抽屉的宽度
  height: 'auto',
  // 抽屉的高度
  destroyOnClose: false,
  // 关闭时候是否销毁抽屉的内容
  container: 'body',
  // 指定 Drawer 挂载的 HTML 节点
  closeIcon: null,
  // 自定义关闭图标
  title: '',
  // 抽屉的头部的标题
  className: '' // 抽屉容器的class, 用来自定义组件样式

};
var DrawerContext = React.createContext && /*#__PURE__*/React.createContext(null);
var Drawer = (_dec = WebUI({
  name: "drawer",
  defaultProps: defaultProps
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(Drawer, _Component);

  var _super = _createSuper(Drawer);

  function Drawer(props) {
    var _this;

    _classCallCheck(this, Drawer);

    _this = _super.call(this, props);
    _this.state = {
      showDrawer: true,
      width: '0',
      push: false
    };
    _this.drawer = null;
    _this.parentDrawer = null;
    bindAll(_assertThisInitialized(_this), ['fMaskClick', 'fDrawerTransitionEnd', 'renderMask', 'renderClose', 'fCloseClick', 'renderBody', 'renderAll']);
    return _this;
  }

  _createClass(Drawer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      //在有父级抽屉时候，子级触发父级向外移动一段距离
      if (preProps.show != this.props.show && this.parentDrawer) {
        if (this.props.show) {
          this.parentDrawer.push();
        } else {
          this.parentDrawer.pull();
        }
      }
    }
  }, {
    key: "push",
    value: function push() {
      this.setState({
        push: true
      });
    }
  }, {
    key: "pull",
    value: function pull() {
      this.setState({
        push: false
      });
    }
  }, {
    key: "fMaskClick",
    value: function fMaskClick() {
      var maskClosable = this.props.maskClosable;

      if (maskClosable) {
        var onClose = this.props.onClose;
        onClose && onClose();
      }
    }
  }, {
    key: "fCloseClick",
    value: function fCloseClick() {
      var onClose = this.props.onClose;
      onClose && onClose();
    }
  }, {
    key: "fDrawerTransitionEnd",
    value: function fDrawerTransitionEnd(e) {}
  }, {
    key: "renderMask",
    value: function renderMask() {
      var _this$props = this.props,
          show = _this$props.show,
          showMask = _this$props.showMask,
          fMaskClick = _this$props.fMaskClick,
          clsPrefix = _this$props.clsPrefix; //mask样式

      var maskStyle;

      if (show) {
        maskStyle = {
          opacity: 1,
          width: '100%'
        };
      } else {
        maskStyle = {
          opacity: 0,
          width: 0
        };
      }

      return showMask ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-mask"),
        style: maskStyle,
        onClick: this.fMaskClick
      }) : null;
    }
  }, {
    key: "renderClose",
    value: function renderClose() {
      var _this$props2 = this.props,
          showClose = _this$props2.showClose,
          closeIcon = _this$props2.closeIcon,
          clsPrefix = _this$props2.clsPrefix;
      var closeDom = closeIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "uf-close"
      });
      return showClose ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(clsPrefix, "-close"),
        onClick: this.fCloseClick
      }, closeDom) : null;
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      var _this2 = this;

      var _this$props3 = this.props,
          destroyOnClose = _this$props3.destroyOnClose,
          show = _this$props3.show,
          clsPrefix = _this$props3.clsPrefix;

      if (destroyOnClose && !show) {
        return null;
      }

      var _this$props4 = this.props,
          hasHeader = _this$props4.hasHeader,
          title = _this$props4.title,
          children = _this$props4.children,
          width = _this$props4.width,
          height = _this$props4.height,
          placement = _this$props4.placement;
      var push = this.state.push; //抽屉类

      var drawerClass = classNames("".concat(clsPrefix), "".concat(clsPrefix, "-").concat(placement)); //根据位置获取抽屉样式

      var translateHideMap = {
        left: 'translateX(-100%)',
        right: 'translateX(100%)',
        top: 'translateY(-100%)',
        bottom: 'translateY(100%)'
      };
      var translateShow = 'translate(0,0)';

      if (push) {
        var pushNum = 50;
        var translateShowMap = {
          left: "translate(".concat(pushNum, "px,0)"),
          right: "translate(-".concat(pushNum, "px,0)"),
          top: "translate(0,".concat(pushNum, "px)"),
          bottom: "translate(0,-".concat(pushNum, "px)")
        };
        translateShow = translateShowMap[placement];
      }

      var translate = show ? translateShow : translateHideMap[placement]; //抽屉面板样式

      if (isNumber(width)) {
        width = width + 'px';
      }

      if (isNumber(height)) {
        height = height + 'px';
      }

      if (placement == 'top' || placement == 'bottom') {
        if (width == 'auto') {
          width = '100%';
        }
      }

      if (placement == 'left' || placement == 'right') {
        if (height == 'auto') {
          height = '100%';
        }
      }

      var drawerStyle = {
        transform: translate,
        WebkitTransform: translate,
        width: width,
        height: height
      };
      var closer = this.renderClose();
      var header = hasHeader ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-header")
      }, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-header-title")
      }, title)) : '';
      return /*#__PURE__*/React.createElement(DrawerContext.Provider, {
        value: this
      }, show && /*#__PURE__*/React.createElement("div", {
        ref: function ref(drawer) {
          _this2.drawer = drawer;
        },
        onTransitionEnd: this.fDrawerTransitionEnd,
        className: drawerClass,
        style: drawerStyle
      }, closer, header, /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "-body")
      }, children)));
    }
  }, {
    key: "renderAll",
    value: function renderAll(value) {
      var _this$props5 = this.props,
          show = _this$props5.show,
          className = _this$props5.className,
          zIndex = _this$props5.zIndex; //容器类

      var drawercClass = classNames('drawerc', className); //容器样式

      var drawercStyle = {
        zIndex: zIndex
      };

      if (show) {
        drawercStyle.width = '100%';
      } else {
        drawercStyle.width = 0;
      } //获取父级抽屉


      this.parentDrawer = value;
      return /*#__PURE__*/React.createElement("div", {
        className: drawercClass,
        style: drawercStyle
      }, this.renderMask(), this.renderBody());
    }
  }, {
    key: "getParent",
    value: function getParent() {
      var container = this.props.container;

      if (typeof container === 'string') {
        return document.querySelector(container);
      }

      if (typeof container === 'function') {
        var returnData = container();

        if (typeof returnData === 'string') {
          return document.querySelector(returnData);
        } else if (_typeof(returnData) === 'object' && returnData instanceof window.HTMLElement) {
          return returnData;
        } else if (_typeof(returnData) === 'object' || typeof returnData === 'number' || typeof returnData === 'boolean' || _typeof(returnData) === undefined) {
          return document.querySelector('body');
        }
      }

      if (_typeof(container) === 'object' && container instanceof window.HTMLElement) {
        return container;
      }

      return document.querySelector('body');
    }
  }, {
    key: "render",
    value: function render() {
      // const {container} = this.props;
      // const conDom = document.querySelector(container);
      var conDom = this.getParent();
      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderAll), conDom);
    }
  }]);

  return Drawer;
}(Component)) || _class);
Drawer.propTypes = propTypes; // Drawer.defaultProps = defaultProps;

export default Drawer;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-drawer/src/Drawer.js